import { SvgStaticImage } from "@gromia/components/SvgStaticImage";
import * as s from "@gromia/components/theme/t.module.css";
import { Text } from "@gromia/components/ui/Text";
import cx from "classnames";
import { pipe } from "fp-ts/lib/function";
import * as O from "fp-ts/lib/Option";
import React from "react";
import * as spriv from "./VerticalMarketingSteps.module.css";

type StepProps = {
  main?: NonNullable<React.ReactNode>;
  side?: NonNullable<React.ReactNode>;
  index?: number;
  last?: boolean;
  noLabel?: boolean;
};

function Circle(props: StepProps) {
  return (
    <React.Fragment>
      <span
        className={cx(
          s.bgPrimaryDarker,
          s.dFlex,
          s.alignItemsCenter,
          s.justifyContentCenter,
          s.fontSizeBig,
          s.textWhite,
          s.fontWeightSemiBold,
          s.roundedCircle,
          s.zIndex2,
          s.positionAbsolute,
          s.top0,
          spriv.circle,
        )}
      >
        {props.noLabel
          ? null
          : pipe(
            O.fromNullable(props.index),
            O.map(x => (x + 1).toString()),
            O.getOrElse(() => "0"),
          )}
      </span>
      <Chevron />
    </React.Fragment>
  );
}

function Chevron(props: { last?: boolean }) {
  return (
    <SvgStaticImage
      alt=""
      src={require("./chevron-down.svg")}
      className={cx(spriv.chevron, props.last ? spriv.chevronLast : null)}
    />
  );
}

export function VerticalMarketingStep(props: StepProps) {
  return (
    <li className={cx(spriv.step)}>
      <div className={cx(spriv.main)}>
        <div className={cx(spriv.content)}>
          <Circle {...props} />
          <div>{props.main}</div>
        </div>
        {props.last ? <Chevron last /> : null}
      </div>
      <div className={cx(spriv.separator)}></div>
      <div className={cx(spriv.side)}>
        <div className={cx(spriv.content)}>{props.side}</div>
      </div>
    </li>
  );
}

type StepsProps = {
  noLabel?: boolean;
  children: Array<React.ReactElement<StepProps>>;
};

export function VerticalMarketingSteps(props: StepsProps) {
  return (
    <ul className={cx(s.container, spriv.steps)}>
      {React.Children.map(props.children, (x, index) =>
        React.cloneElement(x, {
          index,
          last: index === React.Children.count(props.children) - 1,
          noLabel: props.noLabel,
        }))}
    </ul>
  );
}

export function VerticalStepContent(props: {
  tag?: NonNullable<React.ReactNode>;
  title: NonNullable<React.ReactNode>;
  text: NonNullable<React.ReactNode>;
}) {
  return (
    <React.Fragment>
      {props.tag
        ? (
          <Text tag="p" s="pill">
            {props.tag}
          </Text>
        )
        : null}
      <Text tag="p" s="titleLarge">
        {props.title}
      </Text>
      <Text tag="p" s="p">
        {props.text}
      </Text>
    </React.Fragment>
  );
}

export function VerticalStepImage(props: { src: string }) {
  return <img role="presentation" alt="" src={props.src} />;
}
